import { render, staticRenderFns } from "./GeneralConfigurations.vue?vue&type=template&id=2ac76f96&scoped=true"
import script from "./GeneralConfigurations.vue?vue&type=script&lang=ts"
export * from "./GeneralConfigurations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac76f96",
  null
  
)

export default component.exports